import { BrandOverlayEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlayDeleteRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlayDeleteRequestDTO.validationSchema(),
    BrandOverlayEntity
  );

  constructor(readonly data: RoomBrandOverlayDeleteRequest) {
    JsonSchemaValidator.assert(
      RoomBrandOverlayDeleteRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandOverlay"],
      properties: {
        roomId,
        brandOverlay: {
          instanceof: BrandOverlayEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandOverlayDeleteRequest {
  roomId: RoomId;
  brandOverlay: BrandOverlayEntity;
}
